(function ($) {
	'use strict';

	$(function () {
		$('[data-referenzen-browser]').each(function () {
			var $browser = $(this);
			var request = null;

			function loadReferences(url, updateHistory, scrollToResults) {
				if (request && request.readyState !== 4) {
					request.abort();
				}

				$browser.addClass('is-loading').attr('aria-busy', 'true');

				request = $.get(url)
					.done(function (html) {
						var $response = $('<div>').append($.parseHTML(html, document, true));
						var $newBrowser = $response.find('[data-referenzen-browser]').first();

						if (!$newBrowser.length) {
							window.location.href = url;
							return;
						}

						$browser.html($newBrowser.html());

						if (updateHistory) {
							window.history.pushState({ referenzenFilter: true }, '', url);
						}

						if (scrollToResults) {
							var headerHeight = $('.site-header').outerHeight() || 0;
							var targetTop = Math.max(0, $browser.offset().top - headerHeight - 24);
							var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

							window.scrollTo({
								top: targetTop,
								behavior: reducedMotion ? 'auto' : 'smooth'
							});
						}
					})
					.fail(function (_, status) {
						if (status !== 'abort') {
							window.location.href = url;
						}
					})
					.always(function () {
						$browser.removeClass('is-loading').removeAttr('aria-busy');
					});
			}

			$browser.on('click', '.referenzen-filter, .referenzen-pagination a', function (event) {
				var url = this.href;

				if (!url || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
					return;
				}

				event.preventDefault();
				loadReferences(url, true, $(this).closest('.referenzen-pagination').length > 0);
			});

			$(window).on('popstate.referenzenFilter', function () {
				loadReferences(window.location.href, false, false);
			});
		});
	});
})(jQuery);
